<section class="hero-reserva" id="reserva">

  <div class="hero-background">
    <img
      src="/banner-paraiso.JPG"
      alt="Paraíso do Cerrado"
    >
  </div>

  <div class="reserva-card">

    <div class="reserva-header">
      <h1>Bem-vindo(a)!</h1>

      <p>
        Descubra o refúgio perfeito para viver momentos inesquecíveis.
      </p>
    </div>

    <div class="reserva-filtros">

      <div class="reserva-item acomodacao-item">

        <span class="reserva-icon">⌂</span>

        <div class="reserva-info">
          <label>Acomodação</label>

          <button
            type="button"
            class="reserva-select"
            (click)="toggleAcomodacoes()"
          >
            {{ acomodacaoSelecionada || 'Selecione uma acomodação' }}

          </button>
        </div>

        <div
          class="dropdown-reserva acomodacoes-dropdown"
          *ngIf="mostrarAcomodacoes"
        >

          <button
            type="button"
            *ngFor="let acomodacao of acomodacoes"
            (click)="selecionarAcomodacao(acomodacao)"
          >
            <span>{{ acomodacao.nome }}</span>

            <small>
              {{ acomodacao.descricao }}
            </small>
          </button>

        </div>

      </div>

      <div class="reserva-item">

        <span class="reserva-icon">▣</span>

        <div class="reserva-info">
          <label>Check-in</label>

          <button
            type="button"
            class="reserva-date"
            (click)="abrirCalendario('entrada')"
          >
            {{ dataEntrada
            ? formatarData(dataEntrada)
            : 'Selecione a data'
            }}
          </button>
        </div>

      </div>

      <div class="reserva-item">

        <span class="reserva-icon">▣</span>

        <div class="reserva-info">
          <label>Check-out</label>

          <button
            type="button"
            class="reserva-date"
            (click)="abrirCalendario('saida')"
          >
            {{ dataSaida
            ? formatarData(dataSaida)
            : 'Selecione a data'
            }}
          </button>
        </div>

      </div>

      <div class="reserva-item hospedes-item">

        <span class="reserva-icon">♙</span>

        <div class="reserva-info">
          <label>Hóspedes</label>

          <button
            type="button"
            class="reserva-select"
            (click)="toggleHospedes()"
          >
            {{ totalHospedes }} hóspedes

          </button>
        </div>

        <div
          class="dropdown-reserva hospedes-dropdown"
          *ngIf="mostrarHospedes"
        >

          <div class="hospede-linha">

            <div>
              <strong>Adultos</strong>
              <small>12 anos ou mais</small>
            </div>

            <div class="contador">

              <button
                type="button"
                (click)="alterarHospedes('adultos', -1)"
              >
                −
              </button>

              <span>{{ adultos }}</span>

              <button
                type="button"
                (click)="alterarHospedes('adultos', 1)"
              >
                +
              </button>

            </div>

          </div>

          <div class="hospede-linha">

            <div>
              <strong>Crianças</strong>
              <small>De 2 a 11 anos</small>
            </div>

            <div class="contador">

              <button
                type="button"
                (click)="alterarHospedes('criancas', -1)"
              >
                −
              </button>

              <span>{{ criancas }}</span>

              <button
                type="button"
                (click)="alterarHospedes('criancas', 1)"
              >
                +
              </button>

            </div>

          </div>

          <div class="hospede-linha">
            <div>
              <strong>Pets</strong>
              <small>Pets (máximo 2)</small>
            </div>

            <div class="contador">
              <button
                type="button"
                [disabled]="animais <= 0"
                (click)="alterarHospedes('animais', -1)"
              >
                −
              </button>

              <span>{{ animais }}</span>

              <button
                type="button"
                [disabled]="animais >= 2"
                (click)="alterarHospedes('animais', 1)"
              >
                +
              </button>
            </div>
          </div>

        </div>

      </div>

      <button
        type="button"
        class="reserva-buscar"
        (click)="buscarDisponibilidade()"
      >
        <span>→</span>
      </button>

    </div>


    <div
      class="calendario-dropdown"
      *ngIf="mostrarCalendario"
    >

      <!-- CABEÇALHO DO CALENDÁRIO -->

      <div class="calendario-header">

        <button
          type="button"
          (click)="mesAnterior()"
          aria-label="Mês anterior"
        >
          ‹
        </button>

        <strong>
          {{ nomesMeses[mesAtual] }}
          {{ anoAtual }}
        </strong>

        <button
          type="button"
          (click)="mesProximo()"
          aria-label="Próximo mês"
        >
          ›
        </button>

      </div>

      <!-- CARREGAMENTO -->

      <div
        class="calendario-aviso"
        *ngIf="carregandoCalendario"
      >
        Consultando disponibilidade e regras de hospedagem...
      </div>

      <!-- ERRO AO CARREGAR -->

      <div
        class="calendario-aviso calendario-erro"
        *ngIf="erroCalendario"
      >
        Não foi possível carregar as regras de hospedagem.
        Selecione novamente a acomodação.
      </div>

      <!-- AVISO DA REGRA DE MÍNIMO DE NOITES -->

      <div
        class="calendario-aviso calendario-regra"
        *ngIf="
      dataEntrada &&
      modoCalendario === 'saida' &&
      !carregandoCalendario &&
      !erroCalendario
    "
      >

        <div class="calendario-regra-titulo">
          <span class="calendario-regra-icone">☾</span>

          <strong>
            Estadia mínima de
            {{ minimoNoitesSelecionado }}
            {{ minimoNoitesSelecionado === 1 ? 'noite' : 'noites' }}
          </strong>
        </div>

        <p>
          Para entrada em
          <strong>{{ formatarData(dataEntrada) }}</strong>,
          o check-out poderá ser realizado a partir de
          <strong>{{ formatarData(checkoutMinimo) }}</strong>.
        </p>

        <small>
          As datas posteriores também poderão ser selecionadas,
          conforme a disponibilidade da acomodação.
        </small>

      </div>

      <!-- DIAS DA SEMANA -->

      <div class="calendario-semana">

        <span>Dom</span>
        <span>Seg</span>
        <span>Ter</span>
        <span>Qua</span>
        <span>Qui</span>
        <span>Sex</span>
        <span>Sáb</span>

      </div>

      <!-- DIAS DO CALENDÁRIO -->

      <div class="calendario-dias">

        <button
          type="button"
          *ngFor="let dia of diasCalendario"

          [class.vazio]="dia.numero === 0"
          [class.hoje]="dia.hoje"
          [class.selecionado]="dia.selecionado"
          [class.intervalo]="dia.intervalo"

          [class.dia-bloqueado]="
        dia.numero !== 0 && dia.desabilitado
      "

          [class.dia-checkout-minimo]="
        modoCalendario === 'saida' &&
        checkoutMinimo !== null &&
        mesmaData(dia.data, checkoutMinimo) &&
        !dia.desabilitado
      "

          [class.dia-checkout-disponivel]="
        modoCalendario === 'saida' &&
        checkoutMinimo !== null &&
        dia.data >= checkoutMinimo &&
        !dia.desabilitado &&
        !dia.selecionado
      "

          [disabled]="
        dia.numero === 0 ||
        dia.desabilitado
      "

          (click)="selecionarData(dia)"
        >

          <ng-container *ngIf="dia.numero !== 0">
            {{ dia.numero }}
          </ng-container>

        </button>

      </div>

      <!-- LEGENDA DO CALENDÁRIO -->

      <div
        class="calendario-legenda"
        *ngIf="
      modoCalendario === 'saida' &&
      dataEntrada &&
      !carregandoCalendario &&
      !erroCalendario
    "
      >

        <div class="legenda-item">
          <span class="legenda-cor legenda-disponivel"></span>
          <span>Check-out permitido</span>
        </div>

        <div class="legenda-item">
          <span class="legenda-cor legenda-bloqueado"></span>
          <span>Indisponível</span>
        </div>

      </div>

      <!-- RODAPÉ -->

      <div class="calendario-footer">

    <span *ngIf="modoCalendario === 'entrada'">
      Selecione o check-in
    </span>

        <span
          *ngIf="
        modoCalendario === 'saida' &&
        !dataEntrada
      "
        >
      Selecione primeiro o check-in
    </span>

        <span
          *ngIf="
        modoCalendario === 'saida' &&
        dataEntrada
      "
        >
      Selecione o check-out a partir de
          {{ formatarData(checkoutMinimo) }}
    </span>

      </div>

    </div>


  </div>

</section>

<section class="acomodacoes-section" id="acomodacoes">

  <h2 class="acomodacoes-title">
    Nossas Acomodações
  </h2>

  <div class="acomodacoes-wrapper">

    <a
      routerLink="/cabana-ype"
      class="acomodacao-card"
    >
      <div class="acomodacao-image">
        <img
          src="/cabana-ype.PNG"
          alt="Cabana Ypê"
        >
      </div>

      <div class="acomodacao-name">
        Cabana Ypê
      </div>
    </a>

    <a
      routerLink="/chale-santorini"
      class="acomodacao-card"
    >
      <div class="acomodacao-image">

        <img
          src="/nova-chale-santorini%20(1).PNG"
          alt="Chalé Santorini"
        >

      </div>

      <div class="acomodacao-name">
        Chalé Santorini
      </div>
    </a>

    <div class="acomodacoes-decoration">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>

  </div>

</section>

<section class="feedback-section">

  <h2 class="feedback-title">
    Quem Já Viveu Essa Experiência
  </h2>

  <div class="feedback-wrapper">

    <div class="feedback-decoration decoration-left">
      <span>+</span>
      <span>+</span>
      <span>+</span>

      <span>+</span>
      <span>+</span>
      <span>+</span>

      <span class="purple">+</span>
      <span>+</span>
      <span>+</span>

      <span class="orange">+</span>
      <span>+</span>
      <span>+</span>
    </div>

    <div class="feedback-card">

      <img
        class="feedback-image"
        [src]="feedbacks[feedbackAtual]"
        alt="Feedback de hóspede"
      >

    </div>

    <div class="feedback-decoration decoration-right">

      <span>+</span>
      <span>+</span>
      <span class="purple">+</span>

      <span>+</span>
      <span>+</span>
      <span>+</span>

      <span class="olive">+</span>
      <span>+</span>
      <span>+</span>

    </div>

    <button
      type="button"
      class="feedback-arrow feedback-prev"
      (click)="feedbackAnterior()"
      aria-label="Feedback anterior"
    >
      <span>‹</span>
    </button>

    <button
      type="button"
      class="feedback-arrow feedback-next"
      (click)="feedbackProximo()"
      aria-label="Próximo feedback"
    >
      <span>›</span>
    </button>

  </div>

  <div class="feedback-dots">

    <button
      *ngFor="let feedback of feedbacks; let i = index"
      type="button"
      class="feedback-dot"
      [class.active]="i === feedbackAtual"
      (click)="irParaFeedback(i)"
      [attr.aria-label]="'Ir para feedback ' + (i + 1)"
    ></button>

  </div>

  <a
    href="#reserva"
    class="feedback-button"
  >
    Reserve sua experiência
  </a>

</section>

<section class="sobre-paraiso" id="sobre">
  <div class="sobre-container">

    <div class="sobre-content">
      <h2>Por trás do Paraíso do Cerrado</h2>

      <p>
        O Paraíso do Cerrado foi criado por um casal, Patrick e Gabriella, com o
        propósito de oferecer um refúgio para os seus hóspedes onde a natureza,
        o conforto e a hospitalidade se encontram. Inspirado na beleza e na
        tranquilidade do Cerrado, cada detalhe foi planejado para que nossos
        hóspedes vivam uma experiência única, longe da correria do dia a dia.
      </p>

      <p>
        Mais do que uma hospedagem, queremos que cada visita seja marcada por
        momentos especiais, seja para descansar, celebrar uma ocasião importante
        ou simplesmente aproveitar a paz que só a natureza pode proporcionar.
      </p>
    </div>

    <div class="sobre-image">
      <div class="image-card">
        <img
          src="/bastidores.png"
          alt="Patrick e Gabriella no Paraíso do Cerrado"
        >
      </div>
    </div>

  </div>
</section>

